import { render, staticRenderFns } from "./MyInstruments.vue?vue&type=template&id=1d8f73ca"
import script from "./MyInstruments.vue?vue&type=script&lang=js"
export * from "./MyInstruments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports